'use client';

import { forwardRef } from 'react';
import type {
  SelectProps,
  CreatableSelectProps as CreatableFlowProps,
} from '@highlight-cp/core-ui';

import { CreatableSelectBase } from './creatable-select-base';

export type CreatableSelectProps = SelectProps & CreatableFlowProps;

/**
 * ### CreatableSelect
 *
 * @description
 * Mantine's Select with the v6-compat `creatable` flow — pass `creatable` to let
 * users add a new option from the current search query, `getCreateLabel` to label
 * the synthetic "create" row, and `onCreate` to resolve the created value. Same
 * restricted style API as the core-ui `Select`.
 *
 * @example
 * <CreatableSelect creatable getCreateLabel={(q) => `+ Create ${q}`} onCreate={handleCreate} />
 *
 * @param props - {@link CreatableSelectProps}
 */
export const CreatableSelect = forwardRef<HTMLInputElement, CreatableSelectProps>((props, ref) => (
  <CreatableSelectBase ref={ref} {...props} />
));
CreatableSelect.displayName = 'CreatableSelect';
